import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { StatusBadge, InitialsBadge } from "../../components/DashboardLayout";
import { Mail, Phone, User } from "lucide-react";
import { toast, Toaster } from "sonner";
import { useAuth } from "../../context/AuthContext";

export default function MesInfos() {
    const { user } = useAuth();
    const [profile, setProfile] = useState(null);

    useEffect(() => {
        api.get("/me/profile").then((r) => setProfile(r.data)).catch(() => toast.error("Erreur de chargement"));
    }, []);

    if (!profile) return <div className="text-white/60 text-sm">Chargement…</div>;

    return (
        <div data-testid="client-page-infos" className="space-y-8 max-w-3xl">
            <Toaster position="top-center" theme="dark" richColors />
            <div>
                <span className="text-xs tracking-[0.3em] text-ice uppercase">— Mon espace</span>
                <h1 className="font-serif text-4xl mt-2">Bonjour {profile.prenom}</h1>
                <p className="text-white/60 mt-2">
                    Retrouvez ici votre suivi, vos rendez-vous et les documents partagés avec votre conseillère.
                </p>
            </div>

            <section className="bg-ink-600 border border-white/10 rounded-xl p-7">
                <div className="flex items-center gap-4">
                    <InitialsBadge value={profile.initials} size="lg" />
                    <div>
                        <h2 className="font-serif text-2xl">
                            {profile.prenom} {profile.nom}
                        </h2>
                        <div className="text-sm text-white/60 mt-1">{profile.niveau}</div>
                    </div>
                    <div className="ml-auto">
                        <StatusBadge status={profile.statut} />
                    </div>
                </div>

                <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5 text-sm">
                    <InfoRow icon={Mail} label="Email">
                        <a href={`mailto:${profile.email}`} className="text-white/85 hover:text-ice break-all">
                            {profile.email}
                        </a>
                    </InfoRow>
                    {profile.parent_email && (
                        <InfoRow icon={Mail} label="Email parent">
                            <span className="text-white/85 break-all">{profile.parent_email}</span>
                        </InfoRow>
                    )}
                    {profile.telephone && (
                        <InfoRow icon={Phone} label="Téléphone">
                            <a href={`tel:${profile.telephone}`} className="text-white/85 hover:text-ice">
                                {profile.telephone}
                            </a>
                        </InfoRow>
                    )}
                    <InfoRow icon={User} label="Suivi par">
                        <InitialsBadge value={profile.suivi_par} size="sm" tone="ice" />
                    </InfoRow>
                </div>
            </section>

            <div className="bg-ice/10 border border-ice/30 rounded-xl p-6 text-sm text-white/85">
                <p>
                    <strong className="text-ice">Astuce :</strong> vous pouvez déposer vos bulletins, CV ou lettres
                    de motivation dans <em>Mes documents</em>. Votre conseillère les verra avant votre prochain RDV.
                </p>
            </div>
        </div>
    );
}

function InfoRow({ icon: Icon, label, children }) {
    return (
        <div>
            <div className="text-xs tracking-[0.2em] text-white/50 uppercase">{label}</div>
            <div className="mt-2 flex items-center gap-2.5">
                <Icon size={15} className="text-ice" />
                {children}
            </div>
        </div>
    );
}
